export enum ConversationTaskAllStatuses {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  DONE = "DONE",
  WONTDO = "WONTDO",
}

export enum ConversationTaskStatus {
  NOT_STARTED = ConversationTaskAllStatuses.NOT_STARTED,
  IN_PROGRESS = ConversationTaskAllStatuses.IN_PROGRESS,
  DONE = ConversationTaskAllStatuses.DONE,
}

export enum ConversationTaskPriority {
  LOW = "LOW",
  NORMAL = "NORMAL",
  HIGH = "HIGH",
}

export enum ConversationTaskType {
  SUMMARY_PUSH = "SUMMARY_PUSH",
  FOLLOW_UP_EMAIL = "FOLLOW_UP_EMAIL",
  CUSTOM = "CUSTOM",
  PDF_FILL = "PDF_FILL",
  EXCEL_FILL = "EXCEL_FILL",
}

export type ConversationTask = {
  id: string;
  title: string;
  description?: string;
  conversationId: string;
  status: ConversationTaskStatus;
  priority: ConversationTaskPriority;
  type: ConversationTaskType;
  dueDate: number | Date;
  assignedTo?: string;
  createdAt: number;
  updatedAt: number;
  crmContactId?: string;
  crmTaskId?: string;
  userId?: string;
};

export enum ConversationTaskPriorityLabels {
  LOW = "Low",
  NORMAL = "Normal",
  HIGH = "High",
}

export enum ConversationTaskLabels {
  NOT_STARTED = "Not started",
  STARTED = "Started",
  IN_PROGRESS = "Pushed to CRM",
  DONE = "Done",
  WONTDO = "Won't do",
  FAILED = "Failed",
}
